import {
  Button, useToastController
} from "@fluentui/react-components";
import { useGlobalStatus } from '../services/GlobalStatusProvider';
import { showErrorToast, showSuccessToast } from "../services/toastUtils";
import { TimesheetExport } from '../services/apiService';
import { TOASTER_ID } from "../services/toastUtils";
import { format } from "date-fns";
import TooltipWatcherWidget from './TooltipWatcherWidget';

export default function ExportToCSV (props) {
    const { useStyles, currentWeekStart } = useGlobalStatus();
    const styles = useStyles();
    const { dispatchToast } = useToastController(TOASTER_ID);

    const handleExport = async (email, type) => {
        try {
          const response = await TimesheetExport(email, currentWeekStart, type);
    
          const url = window.URL.createObjectURL(response);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Timesheets_Export_${format(currentWeekStart,'MMMM')}.csv`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          showSuccessToast(dispatchToast, "Successfully exported data");
        } catch (error) {
          showErrorToast(dispatchToast, "Failed to export");
        }
      }

      return (
        <TooltipWatcherWidget text={`Export ${props.type}`} direction="below-start">
          <Button className={styles.buttonPrimary} onClick={() => handleExport(props.email, props.type)}>{props.text}</Button>
        </TooltipWatcherWidget>
      )
}